import { render, staticRenderFns } from "./GdTabs.vue?vue&type=template&id=0e3a6007"
import script from "./GdTabs.vue?vue&type=script&lang=js"
export * from "./GdTabs.vue?vue&type=script&lang=js"
import style0 from "./GdTabs.vue?vue&type=style&index=0&id=0e3a6007&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports